function getIOSVersion() {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        var v = navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
        var version = [parseInt(v[1], 10), parseInt(v[2], 10), parseInt(v[3] || 0, 10)];

        return version[0];
    }

    return 16;
}

export const isDev = process.env.NODE_ENV === 'development';
export const isIOS = /iPhone|iPad|iPod|mac/i.test(navigator.userAgent) ;
export const isAndroid =  !isIOS;
export const iosVersion = getIOSVersion();
